"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CliCommandError = void 0;
class CliCommandError extends Error {
    constructor(...args) {
        super(...args);
        this.code = 422;
        this.name = 'CliCommandError';
        Error.captureStackTrace(this, CliCommandError);
    }
}
exports.CliCommandError = CliCommandError;
//# sourceMappingURL=cli-command-error.js.map